/// <reference types="jquery" />

import ko = require("knockout");
import Q = require("q");

import Contracts_FormInput = require("VSS/Common/Contracts/FormInput");
import Context = require("VSS/Context");
import Controls_Combos = require("VSS/Controls/Combos");
import Service = require("VSS/Service");
import Utils_Core = require("VSS/Utils/Core");
import Utils_String = require("VSS/Utils/String");
import Utils_UI = require("VSS/Utils/UI");
import VSS = require("VSS/VSS");
import KnockoutCommon = require("DistributedTasksCommon/TFS.Knockout.CustomHandlers");
import Resources = require("DistributedTasksCommon/Resources/TFS.Resources.DistributedTasksLibrary");
import ServiceEndpoint_Common = require("DistributedTasksCommon/ServiceEndpoints/ServiceEndpoint.Common");
import ServiceEndpoint_Controls = require("DistributedTasksCommon/ServiceEndpoints/ServiceEndpoint.Controls");
import ServiceEndpoint_Utils = require("DistributedTasksCommon/ServiceEndpoints/ServiceEndpoint.Utils");
import DistributedTaskModels = require("DistributedTasksCommon/TFS.Tasks.Models");
import DistributedTask_Contracts = require("TFS/DistributedTask/Contracts");
import ServiceEndpoint_Contracts = require("TFS/ServiceEndpoint/Contracts");
import * as AzureRMEndpointsManageDialog_NO_REQUIRE from "DistributedTasksCommon/ServiceEndpoints/AzureRMEndpointsManageDialog";
import { FeatureAvailabilityService } from "VSS/FeatureAvailability/Services";
import { MarkdownRenderer } from "ContentRendering/Markdown";
import TaskUtils = require("DistributedTasksCommon/TFS.Tasks.Utils");
import "VSS/LoaderPlugins/Css!DistributedTasksLibrary";
KnockoutCommon.initKnockoutHandlers(true);

export class KubernetesCluster {
    public Context: string = "";
    public Url: string = "";
}

export class SpnCreateMethod {
    public static Manual: string = "Manual";
    public static Automatic: string = "Automatic";
}

class KubernetesEndpointUtils {
    public static showAzureSubscriptionBasedOption(): boolean {
        var defaultPageContext = Context.getPageContext();
        var isHosted: boolean = !!defaultPageContext.webAccessConfiguration.isHosted;
        return isHosted;
    }

    public static getDefaultAuthorizationType(): string {
        return KubernetesEndpointUtils.showAzureSubscriptionBasedOption() ? "AzureSubscription" : "Kubeconfig";
    }
}

export class AddKubernetesEndpointModel extends ServiceEndpoint_Controls.AddServiceEndpointModel {

    public dialogTemplate: string = "add_kubernetes_connections_dialog";

    public existingAuthorizationType: KnockoutObservable<string> = ko.observable("");
    public authorizationType: KnockoutObservable<string> = ko.observable(KubernetesEndpointUtils.getDefaultAuthorizationType());
    public authenticationScheme: KnockoutObservable<string> = ko.observable("");
    public showAzureSubscriptionBasedOption: KnockoutObservable<boolean> = ko.observable(KubernetesEndpointUtils.showAzureSubscriptionBasedOption());
    public isServiceAccountAuthorization: KnockoutComputed<boolean> = ko.computed(() => { return this.authorizationType() === "ServiceAccount" });
    public isKubeconfigAuthorization: KnockoutComputed<boolean> = ko.computed(() => { return this.authorizationType() === "Kubeconfig" });
    public isAzureSubscriptionAuthorization: KnockoutComputed<boolean> = ko.computed(() => { return this.authorizationType() === "AzureSubscription" });
    public isExistingAuthorizationTypeAzureSubscription: KnockoutComputed<boolean> = ko.computed(() => { return Utils_String.equals(this.existingAuthorizationType(), "AzureSubscription", true) });
    public isKubernetesAuthScheme: KnockoutComputed<boolean> = ko.computed(() => { return this.isKubeconfigAuthorization() || this.isAzureSubscriptionAuthorization() });
    public serverUrl: KnockoutObservable<string> = ko.observable("");
    public isServerUrlInvalid: KnockoutComputed<boolean> = null;
    public description: KnockoutObservable<string> = ko.observable("");
    public environmentsList: KnockoutObservableArray<string> = ko.observableArray([]);
    public cloudUrl: KnockoutObservable<string> = ko.observable("");
    public environmentName: KnockoutObservable<string> = ko.observable("");
    public selectedEnvironment: KnockoutObservable<string> = ko.observable("");
    public spnClientId: KnockoutObservable<string> = ko.observable("");
    public spnKey: KnockoutObservable<string> = ko.observable("");
    public selectedClusterUrl: KnockoutObservable<string> = ko.observable("");
    private _endpointType: ServiceEndpoint_Contracts.ServiceEndpointType = null;
    public spnCreationMode: KnockoutObservable<string> = ko.observable(Utils_String.empty);

    public isCreatedFromSecretYaml: KnockoutObservable<boolean> = ko.observable(false);
    public serviceAccountSecretYaml: KnockoutObservable<string> = ko.observable("");
    public serviceAccountToken: KnockoutObservable<string> = ko.observable("");
    public serviceAccountCertificate: KnockoutObservable<string> = ko.observable("");

    public kubeConfig: KnockoutObservable<string> = ko.observable("");
    public acceptUntrustedCerts: KnockoutObservable<boolean> = ko.observable(false);
    public dialogTitle: KnockoutObservable<string> = ko.observable("");
    public authSchemeSelectorText: string = Resources.KubernetesChooseAuthTypeText;

    public clusterContextList: KnockoutObservableArray<KubernetesCluster> = ko.observableArray([]);
    public refreshClusterContextList: KnockoutObservable<boolean> = ko.observable(false);
    public clusterContext: KnockoutObservable<string> = ko.observable("");
    private _disposalManager: Utils_Core.DisposalManager = new Utils_Core.DisposalManager();

    public serviceAccountSetupInProgress: KnockoutObservable<boolean> = ko.observable(false);
    public pollingInProgress: KnockoutObservable<boolean> = ko.observable(false);
    public subscriptionList: KnockoutObservableArray<DistributedTask_Contracts.AzureSubscription> = ko.observableArray([]);
    public subscriptionId: KnockoutObservable<string> = ko.observable("");
    public subscriptionName: KnockoutObservable<string> = ko.observable("");
    public subscriptionTenantId: KnockoutObservable<string> = ko.observable("");

    public oauthAccessTokenKey: KnockoutObservable<string> = ko.observable("");
    public isOAuthFlowInProgress: KnockoutObservable<boolean> = ko.observable(false);

    public refreshClustersList: KnockoutObservable<boolean> = ko.observable(false);
    public refreshNamespacesList: KnockoutObservable<boolean> = ko.observable(false);

    public aksClustersList: KnockoutObservableArray<any> = ko.observableArray([]);
    public namespacesList: KnockoutObservableArray<string> = ko.observableArray([]);

    public selectedClusterId: KnockoutObservable<string> = ko.observable("");
    public selectedNamespace: KnockoutObservable<string> = ko.observable("");
    public operationStatusMessage: KnockoutObservable<string> = ko.observable("");
    public renewServiceAccount: KnockoutObservable<boolean> = ko.observable(false);

    public showVerifyConnection: KnockoutComputed<boolean> = this._disposalManager.addDisposable(ko.computed(() => {
        if (this.isKubeconfigAuthorization()) {
            return true;
        }

        return false;
    }));

    public showServerUrl: KnockoutComputed<boolean> = this._disposalManager.addDisposable(ko.computed(() => {
        //back-compact: show only for existing endpoints that don't have a chosen cluster 
        if (this.isKubeconfigAuthorization() && this.isUpdate() && !this.clusterContext()) {
            return true;
        }

        if (this.isServiceAccountAuthorization()) {
            return true;
        }

        return false;
    }));

    public isNewServiceAccountUI: KnockoutComputed<boolean> = this._disposalManager.addDisposable(ko.computed(() => {    
        return true;
    }));

    public enableClusterDropdown: KnockoutComputed<boolean> = this._disposalManager.addDisposable(ko.computed(() => {
        //disable only if kubeconfig is not populated
        if (!this.isUpdate() && (!this.kubeConfig())) {
            return false;
        }

        return true;
    }));

    public operationStatusMessageWithPrefix = this._disposalManager.addDisposable(ko.computed(function () {
        return Resources.KubernetesOperationStatusMessagePrefix + this.operationStatusMessage();
    }, this));

    public selectedClusterDisplayName = this._disposalManager.addDisposable(ko.computed(function () {
        return this.getClusterDisplayNameFromClusterId(this.selectedClusterId());
    }, this));

    public aksClusterNamesList = this._disposalManager.addDisposable(ko.computed(function () {
        const clusterList = this.aksClustersList();
        let clusterNames: string[] = clusterList ? clusterList.map( cluster => this.getClusterDisplayName(cluster) ) : [];
        return clusterNames;
    }, this));
    
    public subscriptionAndIdList = this._disposalManager.addDisposable(ko.computed(function () {
        const subscriptionList = this.subscriptionList();
        let nameAndIdList: string[] = subscriptionList ? subscriptionList.map( subscription => this.getSubscriptionDisplayValue(subscription.subscriptionId, subscription.displayName) ) : [];
        return nameAndIdList;
    }, this));

    public subscriptionAndId = this._disposalManager.addDisposable(ko.computed({
        read: function () {
            let selectedEntry = this.getSubscriptionDisplayValue(this.subscriptionId(), this.subscriptionName());
            return selectedEntry;
        },
        write: function (value) {
            if (value !== undefined && value !== null) {
                let indexOfSelectedEntry = this.subscriptionAndIdList().indexOf(value);
                const subscriptions = this.subscriptionList.peek();
                const selectedSubscription = subscriptions[indexOfSelectedEntry];
                this.subscriptionName(selectedSubscription.displayName);
                if (selectedSubscription.subscriptionTenantId !== this.subscriptionTenantId()) {
                    this.oauthAccessTokenKey(Utils_String.empty);
                }

                this.subscriptionTenantId(selectedSubscription.subscriptionTenantId);
                this.subscriptionId(selectedSubscription.subscriptionId);
                this.spnKey(selectedSubscription.spnKey);
                this.selectedClusterId(selectedSubscription.selectedClusterId);
                this.selectedNamespace(selectedSubscription.selectedNamespace);
                this.spnClientId(selectedSubscription.spnClientId);
            }
        },
        owner: this
    }));

    public updateKubeconfigPlaceholderText: string = "********";
    public verifyConnectionStatus: KnockoutObservable<string> = ko.observable("");
    public verifyConnectionStatusCssTextClass: KnockoutObservable<string> = ko.observable("");
    public verifyConnectionStatusCssIconClass: KnockoutObservable<string> = ko.observable("");

    protected _distributedTaskClient: DistributedTaskModels.ConnectedServicesClientService;

    public environmentUrl: string = "";
    public kubernetesHelpMarkdown: string;
    public kubernetesServerUrlHelpText: string = Resources.KubernetesServerUrlHelpText;
    public acceptUntrustedCertsHelpText: string = Resources.KubernetesAcceptUntrustedCertsHelpText;
    public kubernetesClusterHelpText: string = Resources.KubernetesClusterHelpText;

    public kubernetesServiceAccountSecretYamlHelpText: string = Resources.KubernetesServiceAccountSecretYamlHelpText;
    public kubernetesServiceAccountTokenHelpText: string = Resources.KubernetesServiceAccountTokenHelpText;
    public kubernetesServiceAccountCertificateHelpText: string = Resources.KubernetesServiceAccountCertificateHelpText;
    public kubernetesServiceAccountDetailsText: string = Resources.KubernetesServiceAccountDetailsHelpSectionText;

    public kubernetesAzureSubscriptionHelpText: string = Resources.KubernetesAzureSubscriptionHelpText;
    public kubernetesAksClusterHelpText: string = Resources.KubernetesAksClusterHelpText;
    public kubernetesNamespaceHelpText: string = Resources.KubernetesNamespaceHelpText;
    public kubernetesRenewServiceAccountHelpText: string = Resources.KubernetesRenewServiceAccountHelpText;

    public learnMoreAboutKubernetesLink: KnockoutComputed<string> = this._disposalManager.addDisposable(ko.computed(() => { 
        if (this.isAzureSubscriptionAuthorization()) {
            return Resources.LearnMoreTextForAzureSubscriptionBasedKubernetesEndpoint;
        }
        else {
            return Resources.LearnMoreAboutKubernetesLink;
        }
     }));

    private _serviceEndpointTypesPromise: IPromise<ServiceEndpoint_Contracts.ServiceEndpointType[]>;
    private _urlValidator: ServiceEndpoint_Utils.UriValidator;
    private _ICON_CLASS_SUCCESS: string = "bowtie-status-success";
    private _ICON_CLASS_FAILURE: string = "bowtie-status-failure";
    private _TEXT_CLASS_SUCCESS: string = "vc-status-success";
    private _TEXT_CLASS_FAILURE: string = "vc-status-failure";
    private _DEFAULT_SELECTED_ENVIRONMENT: string = "AzureCloud";

    constructor(successCallBack: (serviceEndpoint: ServiceEndpoint_Contracts.ServiceEndpoint) => void, options?: any) {
        super(successCallBack);

        let renderer = new MarkdownRenderer();
        this.kubernetesHelpMarkdown = renderer.renderHtml(Resources.KubernetesHelpText);
        this.verifyConnectionStatus(Resources.ConnectionStatusNotVerified);
        this.selectedEnvironment(this._DEFAULT_SELECTED_ENVIRONMENT);
        this.spnCreationMode(SpnCreateMethod.Automatic);
        this.environmentName("AzureCloud");
        this.cloudUrl("https://management.azure.com/");

        this._disposalManager.addDisposable(this.kubeConfig.subscribe((kubeConfig: string) => {
            //populate the cluster list when there is a change in the kubeconfig
            if (!!kubeConfig && kubeConfig !== this.updateKubeconfigPlaceholderText) {
                this.refreshClusterContextList(true);
                this.getClusterContexts();
            }
        }));

        this.selectedEnvironment.subscribe((selectedEnvironmentName) => {
            if (!!this._endpointType && !!this._endpointType.endpointUrl && !!this._endpointType.endpointUrl.dependsOn) {
                for (var i = 0; i < this._endpointType.endpointUrl.dependsOn.map.length; i++) {
                    if (this._endpointType.endpointUrl.dependsOn.map[i].key === selectedEnvironmentName) {
                            this.cloudUrl(this._endpointType.endpointUrl.dependsOn.map[i].value);
                            this.environmentName(selectedEnvironmentName);
                        break;
                    }
                }
            }
        });

        this._disposalManager.addDisposable(this.verifyConnectionStatus.subscribe((value: string) => {
            var statusIconCssClass = "";

            if (Utils_String.equals(value, Resources.ConnectionStatusVerified, true)) {
                this.verifyConnectionStatusCssTextClass(this._TEXT_CLASS_SUCCESS);
                // add status to the icon class to get the correct color (bowtie icons are all gray)
                statusIconCssClass = [this._ICON_CLASS_SUCCESS, this.verifyConnectionStatusCssTextClass()].join(" ");
                this.verifyConnectionStatusCssIconClass(statusIconCssClass);
            }
            else if (Utils_String.equals(value, Resources.ConnectionStatusFailed, true)) {
                this.verifyConnectionStatusCssTextClass(this._TEXT_CLASS_FAILURE);
                // add status to the icon class to get the correct color (bowtie icons are all gray)
                statusIconCssClass = [this._ICON_CLASS_FAILURE, this.verifyConnectionStatusCssTextClass()].join(" ");
                this.verifyConnectionStatusCssIconClass(statusIconCssClass);
            } else {
                this.verifyConnectionStatusCssTextClass("");
                this.verifyConnectionStatusCssIconClass("");
            }
        }));

        this._disposalManager.addDisposable(this.serviceAccountSecretYaml.subscribe((serviceAccountSecretYaml: string) => {
            if (!!serviceAccountSecretYaml) {
                this.parseSaSecretYamlAndPopulateSaTokenAndSaCertfield();
            }
        }));

        var connection: Service.VssConnection = new Service.VssConnection(Context.getDefaultWebContext());
        this._distributedTaskClient = connection.getService<DistributedTaskModels.ConnectedServicesClientService>(DistributedTaskModels.ConnectedServicesClientService);
        this._urlValidator = new ServiceEndpoint_Utils.UriValidator(<Contracts_FormInput.InputValidation>{
            dataType: Contracts_FormInput.InputDataType.Uri,
            isRequired: true
        });

        this.isServerUrlInvalid = this._disposalManager.addDisposable(ko.computed(() => {
            var value = this.serverUrl();
            return !this._urlValidator.validate(value);
        }));
		
		this._serviceEndpointTypesPromise = this._distributedTaskClient.beginGetServiceEndpointTypes(ServiceEndpoint_Common.ServiceEndpointType.Kubernetes);

        this._serviceEndpointTypesPromise.then((endpointTypes: ServiceEndpoint_Contracts.ServiceEndpointType[]) => {
            if (!!endpointTypes && endpointTypes.length === 1) {
                this._endpointType = endpointTypes[0];

                if ((!!this._endpointType.endpointUrl.dependsOn) && (this._endpointType.endpointUrl.dependsOn.input === "azureEnvironment")) {
                    for (var i = 0; i < this._endpointType.endpointUrl.dependsOn.map.length; i++) {
                        this.environmentsList.push(this._endpointType.endpointUrl.dependsOn.map[i].key);
                    }
                }

                if (!!this._endpointType.endpointUrl && !!this._endpointType.endpointUrl.value) {
                    this.cloudUrl(this._endpointType.endpointUrl.value);
                    //this.environmentName(this._endpointType.endpointUrl.key);
                }
            }
        }, (error) => {
            this.errors.push(Resources.CouldNotFetchEndpointTypes);
        });
    }

    public isSovereignFeatureEnabled(): boolean {
        return FeatureAvailabilityService.isFeatureEnabled(ServiceEndpoint_Common.FeatureAvailabilityFlags.EnableSovereignSupportInKubernetesEndpoint, false);
    }

    public isSpnCreationModeAutomatic() {
        return Utils_String.equals(this.spnCreationMode(), SpnCreateMethod.Automatic, true);
    }

    public isSpnCreationModeManual() {
        return Utils_String.equals(this.spnCreationMode(), SpnCreateMethod.Manual, true);
    }
	
    public switchSpnCreationMode(): void {
        // flip the SPN creation when user clicks on "use the full version of endpoint dialog" or "use the automated version"
        this.errors([]);
        if (this.isSpnCreationModeAutomatic()) {
            this.spnCreationMode(SpnCreateMethod.Manual);
        }
        else {
            this.spnCreationMode(SpnCreateMethod.Automatic);
        }
    }

    public dispose() {
        this._disposalManager.dispose();
    }

    public verifyConnection(): void {
        this.verifyConnectionStatus(Resources.ConnectionStatusVerifying);
        this.errors([]);

        if (this.isKubeconfigAuthorization()) {
            this.verifyConnectionForKubeconfig();
        }
        else if (this.isServiceAccountAuthorization()) {
            this.verifyConnectionForServiceAccount();
        }
    }

    private verifyConnectionForKubeconfig(): void {

        this.authenticationScheme(ServiceEndpoint_Common.EndpointAuthorizationSchemes.Kubernetes);
        this.createServiceEndpointRequestAndVerifyConnection();
    }

    private verifyConnectionForServiceAccount(): void {
        this.authenticationScheme(ServiceEndpoint_Common.EndpointAuthorizationSchemes.Token);
        this.createServiceEndpointRequestAndVerifyConnection();
    }

    private createServiceEndpointRequestAndVerifyConnection(headers: Array<ServiceEndpoint_Contracts.AuthorizationHeader> = null): void {
        var resultTransformationDetails: ServiceEndpoint_Contracts.ResultTransformationDetails = {
            resultTemplate: "",
            callbackContextTemplate: "",
            callbackRequiredTemplate: ""
        };

        var dataSourceDetails: ServiceEndpoint_Contracts.DataSourceDetails = {
            dataSourceName: "TestConnection",
            headers: headers,
            dataSourceUrl: "",
            requestContent: null,
            requestVerb: null,
            resourceUrl: "",
            parameters: null,
            resultSelector: "",
            initialContextTemplate: ""
        };

        var serviceEndpointDetails = this.getServiceEndpoint();

        var serviceEndpointRequest: ServiceEndpoint_Contracts.ServiceEndpointRequest = {
            dataSourceDetails: dataSourceDetails,
            resultTransformationDetails: resultTransformationDetails,
            serviceEndpointDetails: serviceEndpointDetails.toServiceEndpointDetails()
        };

        this.verifyConnectedService(serviceEndpointRequest, this.id()).then((result: ServiceEndpoint_Contracts.ServiceEndpointRequestResult) => {
        }, (error) => {
            this.verifyConnectionStatus(Resources.ConnectionStatusFailed);
            this.errors.push(error);
        });
    }

    private verifyConnectedService(serviceEndpointRequest: ServiceEndpoint_Contracts.ServiceEndpointRequest, endpointId: string): IPromise<ServiceEndpoint_Contracts.ServiceEndpointRequestResult> {
        var verifyConnectionPromise = this._distributedTaskClient.beginExecuteServiceEndpointRequest(serviceEndpointRequest, endpointId);

        return verifyConnectionPromise.then((result: ServiceEndpoint_Contracts.ServiceEndpointRequestResult) => {
            if ((Utils_String.equals(result.statusCode, "ok", true)) && !result.errorMessage || !result.errorMessage.trim()) {
                this.verifyConnectionStatus(Resources.ConnectionStatusVerified);
            } else {
                this.verifyConnectionStatus(Resources.ConnectionStatusFailed);
                if (!this.acceptUntrustedCerts()) {
                    this.errors.push(Resources.KubernetesCheckAcceptUntrustedCertErrorHelpText);
                }
                else {
                    this.errors.push(result.errorMessage);
                }
            }

            return Q.resolve(result);
        }, (error) => {
            var errorMsg = error;
            if (!!error && !!error.serverError && !!error.serverError.innerException) {
                errorMsg = errorMsg + Utils_String.newLine + error.serverError.innerException.message;
            }

            return Q.reject(new Error(errorMsg));
        });
    }

    public onKeyDown(data: any, event: JQueryEventObject): boolean {
        var currentElement: JQuery = $(event.target);

        switch (event.keyCode) {
            case Utils_UI.KeyCode.ENTER:
                currentElement.click();
                return false;
            case Utils_UI.KeyCode.SPACE:
                currentElement.click();
                return false;
            default:
                return true;
        }
    }

    public createServiceEndpoint(): IPromise<ServiceEndpoint_Contracts.ServiceEndpoint> {
        var defer = Q.defer<ServiceEndpoint_Contracts.ServiceEndpoint>();

        var connectionIdTemp = this.id.peek().trim();
        if (!connectionIdTemp) {
            connectionIdTemp = ServiceEndpoint_Utils.GUIDUtils.newGuid();
        }

        if (this.isKubernetesAuthScheme()) {
            this.authenticationScheme(ServiceEndpoint_Common.EndpointAuthorizationSchemes.Kubernetes);
        }
        else if (this.isServiceAccountAuthorization()) {
            this.authenticationScheme(ServiceEndpoint_Common.EndpointAuthorizationSchemes.Token);
        }

        return this.beginCreateServiceEndpoint();
    }

    public updateServiceEndpoint(): IPromise<ServiceEndpoint_Contracts.ServiceEndpoint> {

        var connectionIdTemp = this.id.peek().trim();
        if (!connectionIdTemp) {
            connectionIdTemp = ServiceEndpoint_Utils.GUIDUtils.newGuid();
        }

        if (this.isKubernetesAuthScheme()) {
            this.authenticationScheme(ServiceEndpoint_Common.EndpointAuthorizationSchemes.Kubernetes);
        }
        else if (this.isServiceAccountAuthorization()) {
            this.authenticationScheme(ServiceEndpoint_Common.EndpointAuthorizationSchemes.Token);
        }

        return this.beginUpdateServiceEndpoint();
    }

    public getServiceEndpoint(): ServiceEndpoint_Common.ServiceEndpointDetails {
        if (this.isKubeconfigAuthorization()) {
            return this.getServiceEndpointForKubeconfig();
        }
        else if (this.isServiceAccountAuthorization()) {
            return this.getServiceEndpointForServiceAccount();
        }
        else if (this.isAzureSubscriptionAuthorization())
        {
            return this.getServiceEndpointForAzureSubscription();
        }
    }

    private getServiceEndpointForKubeconfig(): ServiceEndpoint_Common.ServiceEndpointDetails {

        var connectionIdTemp = this.id.peek().trim();
        if (!connectionIdTemp) {
            connectionIdTemp = ServiceEndpoint_Utils.GUIDUtils.newGuid();
        }

        var kubeConfig = this.kubeConfig();

        if ((!kubeConfig || kubeConfig === "") && this.isUpdate()) {
            kubeConfig = null;
        }

        var apiData: ServiceEndpoint_Common.KubernetesServiceEndpointApiData = {
            endpointId: connectionIdTemp,
            endpointName: this.name().trim(),
            url: this.serverUrl().trim(),
            type: ServiceEndpoint_Common.ServiceEndpointType.Kubernetes,
            scheme: this.authenticationScheme(),
            parameters: {
                authorizationType: this.authorizationType()
            },
            description: this.description()
        };

        var authorizationInfo: ServiceEndpoint_Contracts.EndpointAuthorization = {
            parameters: {
                kubeconfig: kubeConfig,
                clusterContext: this.clusterContext().trim()
            },
            scheme: this.authenticationScheme()
        };

        apiData.parameters["acceptUntrustedCerts"] = this.acceptUntrustedCerts().toString();

        return new ServiceEndpoint_Common.KubernetesServiceEndpointDetails(apiData, authorizationInfo);
    }

    private getServiceEndpointForServiceAccount(): ServiceEndpoint_Common.ServiceEndpointDetails {

        var connectionIdTemp = this.id.peek().trim();
        if (!connectionIdTemp) {
            connectionIdTemp = ServiceEndpoint_Utils.GUIDUtils.newGuid();
        }

        var endpointUrl = this.serverUrl();
        
        let serviceAccountToken = this.serviceAccountToken() ? this.serviceAccountToken() : null;
        if (serviceAccountToken === "" && this.isUpdate()) {
            serviceAccountToken = null;
        }

        let serviceAccountCertificate = this.serviceAccountCertificate() ? this.serviceAccountCertificate() : null;
        if (serviceAccountCertificate === "" && this.isUpdate()) {
            serviceAccountCertificate = null;
        }

        var apiData: ServiceEndpoint_Common.KubernetesServiceEndpointApiData = {
            endpointId: connectionIdTemp,
            endpointName: this.name().trim(),
            url: this.serverUrl().trim(),
            type: ServiceEndpoint_Common.ServiceEndpointType.Kubernetes,
            scheme: this.authenticationScheme(),
            parameters: {
                authorizationType: this.authorizationType()
            }
        };

        var authorizationInfo: ServiceEndpoint_Contracts.EndpointAuthorization = {
            parameters: {
                apiToken: serviceAccountToken,
                serviceAccountCertificate: serviceAccountCertificate
            },

            scheme: this.authenticationScheme()
        };
        
        return new ServiceEndpoint_Common.KubernetesServiceEndpointDetails(apiData, authorizationInfo);
    }

    private getServiceEndpointForAzureSubscription(): ServiceEndpoint_Common.ServiceEndpointDetails {

        var connectionIdTemp = this.id.peek().trim();
        if (!connectionIdTemp) {
            connectionIdTemp = ServiceEndpoint_Utils.GUIDUtils.newGuid();
        }

        var apiData: ServiceEndpoint_Common.KubernetesServiceEndpointApiData = {
            endpointId: connectionIdTemp,
            endpointName: this.name().trim(),
            url: this.selectedClusterUrl().trim(),
            type: ServiceEndpoint_Common.ServiceEndpointType.Kubernetes,
            scheme: this.authenticationScheme(),
            parameters: {
                authorizationType: this.authorizationType(),
                azureSubscriptionId: this.subscriptionId().trim(),
                azureSubscriptionName: this.subscriptionName().trim(),
                clusterId: this.selectedClusterId().trim(),
                namespace: this.selectedNamespace().trim()
            }
        };

        if (this.renewServiceAccount()) {
            apiData.parameters["operation.type"] = "update";
        }

        var authorizationInfo: ServiceEndpoint_Contracts.EndpointAuthorization = {
            parameters: {
                serviceAccountCertificate: null,
                apiToken: null,
                azureTenantId: this.subscriptionTenantId().trim(),
                azureAccessToken: this.oauthAccessTokenKey() ? this.oauthAccessTokenKey() : null,
                azureEnvironment: this.environmentName()
            },
            scheme: this.authenticationScheme()
        };

        if(this.isSovereignFeatureEnabled())
        {
            authorizationInfo.parameters["spnCreationMethod"] = this.spnCreationMode();
            if(this.spnCreationMode() == SpnCreateMethod.Manual)
            {
                authorizationInfo.parameters["spnId"] = this.spnClientId().trim();
                authorizationInfo.parameters["spnKey"] = this.spnKey().trim();
            }
        }

        return new ServiceEndpoint_Common.KubernetesServiceEndpointDetails(apiData, authorizationInfo);
    }

    private beginCreateServiceEndpoint(): IPromise<ServiceEndpoint_Contracts.ServiceEndpoint> {
        var serviceEndpoint = this.getServiceEndpoint().toServiceEndpoint();
        var defer = Q.defer<ServiceEndpoint_Contracts.ServiceEndpoint>();
        this._distributedTaskClient.beginCreateServiceEndpoint(serviceEndpoint).then((response: ServiceEndpoint_Contracts.ServiceEndpoint) => {
            if (!this.isLongRunningOperation()) {
                defer.resolve(response);

                // Decoupling authorization from creation of endpoint.
                if(this.isPipelineAuthorizationEnabled()) {
                    this._distributedTaskClient.authorizeEndpoint(response).then(() => {}, (error) => {defer.reject(error)});
                }
            }
            else {
                this.waitForServiceAccountSetupToComplete(response.id).then((provisionEndpointResponse) => {
                    defer.resolve(provisionEndpointResponse);

                    // Authorization is attempted after SPN setup.
                    if(this.isPipelineAuthorizationEnabled()) {
                        this._distributedTaskClient.authorizeEndpoint(provisionEndpointResponse).then(() => {}, (error) => {defer.reject(error)});
                    }
                }, (error) => {
                    try {
                        this._distributedTaskClient.beginDeleteServiceEndpoint(response.id);
                    } catch (e) {}

                    defer.reject(error);
                });
            }
        }, (error) => {
            defer.reject(error);
        });

        return defer.promise;
    }

    private beginUpdateServiceEndpoint(): IPromise<ServiceEndpoint_Contracts.ServiceEndpoint> {
        let deferAuthorization = Q.defer<boolean>();
        if (this.renewServiceAccount()) {
            // If renewServiceAccount is checked, call the authorize flow. This will open the OAuth pop-up if required.
            VSS.using(["DistributedTasksCommon/ServiceEndpoints/AzureRMEndpointsManageDialog"], (AzureRMEndpointsManageDialog: typeof AzureRMEndpointsManageDialog_NO_REQUIRE) => {
                const authInProgress = (authInProgress: boolean) => {
                    this.isOAuthFlowInProgress(authInProgress);
                };
                
                AzureRMEndpointsManageDialog.AzureRmEndpointUtils.getAccessTokenKey(this._distributedTaskClient, this.subscriptionTenantId(), authInProgress, this.oauthAccessTokenKey())
                .then((accessTokenKey) => {
                    this.isOAuthFlowInProgress(false);
                    if (!!accessTokenKey) {
                        this.oauthAccessTokenKey(accessTokenKey);
                    }
                    deferAuthorization.resolve(true);
                }, (error) => {
                    // invalidate the access token key
                    this.oauthAccessTokenKey(Utils_String.empty);
                    let errorMessage = Resources.ErrorWhileAuthorizingOnSubscription;
                    if (!!error) {
                        errorMessage = errorMessage + " " + Resources.ErrorPrefix + error;
                    }

                    this.errors.push(errorMessage);   
                    deferAuthorization.reject(errorMessage);
                });
            });
        }
        else {
            deferAuthorization.resolve(true);
        }

        var defer = Q.defer<ServiceEndpoint_Contracts.ServiceEndpoint>();
        deferAuthorization.promise.then(() => {
            var serviceEndpoint = this.getServiceEndpoint().toServiceEndpoint();
            this._distributedTaskClient.beginUpdateServiceEndpoint(serviceEndpoint).then((response: ServiceEndpoint_Contracts.ServiceEndpoint) => {
                TaskUtils.pickServiceEndpointNameAndDescriptionFromServiceEndpointProjectReference(response);
                if (!this.isLongRunningOperation()) {
                    defer.resolve(response);
                }
                else {
                    this.waitForServiceAccountSetupToComplete(response.id).then((provisionEndpointResponse) => {
                        defer.resolve(provisionEndpointResponse);
                    }, (error) => {
                        defer.reject(error);
                    });
                }
            }, (error) => {
                defer.reject(error);
            });
        }, (error) => {
            // do nothing, as error is already pushed to this.errors list, by the deferAuthorization promise error block.
        });        
        
        return defer.promise;
    }

    private waitForServiceAccountSetupToComplete(endpointId: string): IPromise<ServiceEndpoint_Contracts.ServiceEndpoint> {

        var defer = Q.defer<ServiceEndpoint_Contracts.ServiceEndpoint>();
        this.serviceAccountSetupInProgress(true);
        this.pollingInProgress(true);

        var operationStatus = { "state": "InProgress", "statusMessage": "" };
        var monitorServiceAccountSetupProgress = new Utils_Core.DelayedFunction(this, 1000, "monitorServiceAccountSetupProgress", () => {

            this._distributedTaskClient.beginGetEndpoint(endpointId).then((response: ServiceEndpoint_Contracts.ServiceEndpoint) => {

                if (response.operationStatus !== null && response.operationStatus !== undefined) {
                    operationStatus = response.operationStatus;
                }

                if (response.isReady) {
                    defer.resolve(response);
                    this.serviceAccountSetupInProgress(false);
                    this.pollingInProgress(false);
                    monitorServiceAccountSetupProgress.cancel();
                }
                else if (operationStatus.state === "Failed") {
                    defer.reject(operationStatus.statusMessage);
                    this.serviceAccountSetupInProgress(false);
                    this.pollingInProgress(false);
                    monitorServiceAccountSetupProgress.cancel();
                }
                else {
                    monitorServiceAccountSetupProgress.reset();
                }
            });
        });
        monitorServiceAccountSetupProgress.start();
        return defer.promise;
    }

    private isLongRunningOperation(): boolean {
        let result = this.isAzureSubscriptionAuthorization();
        if (this.isUpdate()) {
            result = result && (!this.isExistingAuthorizationTypeAzureSubscription() || this.renewServiceAccount());
        }

        return result;
    }

    //compute the selected cluster context and populate cluster context and server url
    public clusterContextAndUrl = ko.computed({
        read: function () {
            var selectedEntry = this.clusterContext();
            return selectedEntry;
        },
        write: function (value) {
            if (!!value) {
                var indexOfSelectedEntry = this.clusterContextNameList().indexOf(value);
                var selectedEntry = this.clusterContextList()[indexOfSelectedEntry];
                this.clusterContext(selectedEntry.Context);
                this.serverUrl(selectedEntry.Url);
            }
        },
        owner: this

    });

    //display only cluster context name in the dropdown
    public clusterContextNameList = ko.computed(function () {
        var contextNameList: string[] = [];
        var clusterContextLength = this.clusterContextList().length;
        for (let i = 0; i < clusterContextLength; ++i) {

            contextNameList.push(this.clusterContextList()[i].Context);
        }

        return contextNameList;
    }, this);

    public getClusterContexts = (): IPromise<boolean> => {
        if (!this.refreshClusterContextList()) {
            return Q.resolve(true);
        }

        let deferred: Q.Deferred<boolean> = Q.defer<boolean>();
        var kubeconfig = this.kubeConfig();
        this.clusterContextList([]);
        this.errors([]);

        VSS.using(["3rdParty/js-yaml"], (jsyaml) => {
            try {

                var parsedKubeConfig = jsyaml.safeLoad(kubeconfig);
                this.refreshClusterContextList(false);

                const currentContextText: string = "current-context";

                if (!parsedKubeConfig || !parsedKubeConfig.clusters) {
                    throw Resources.KubernetesInvalidKubeconfig;
                }

                parsedKubeConfig.contexts.forEach((context) => {
                    var kubeCluster = new KubernetesCluster();
                    if (!context.name) {
                        throw Utils_String.localeFormat(Resources.KubernetesKubeconfigFieldNotPresent, "context.name");
                    }

                    kubeCluster.Context = context.name;

                    if (!context.context.cluster) {
                        throw Utils_String.localeFormat(Resources.KubernetesKubeconfigFieldNotPresent, "context.context.cluster");
                    }

                    var cluster = parsedKubeConfig.clusters.find(c => Utils_String.equals(c.name, context.context.cluster, true));
                    if (!cluster) {
                        throw Utils_String.localeFormat(Resources.KubernetesKubeconfigFieldNotPresent, "cluster");
                    }

                    if (!cluster.cluster.server) {
                        throw Utils_String.localeFormat(Resources.KubernetesKubeconfigFieldNotPresent, "cluster.cluster.server");
                    }

                    kubeCluster.Url = cluster.cluster.server;
                    this.clusterContextList.push(kubeCluster);

                    if (!this.clusterContext()) {
                        var currentContext = this.getKubeConfigFieldValue(parsedKubeConfig, currentContextText);

                        if (!!currentContext && kubeCluster.Context === currentContext) {
                            this.clusterContext(kubeCluster.Context);
                            this.serverUrl(kubeCluster.Url);
                        }
                    } else if (this.clusterContext() === kubeCluster.Context) {
                        this.serverUrl(kubeCluster.Url);
                    }
                });
            }
            catch (error) {
                this.errors.push(error);
                deferred.reject(error);
            }
        });
    }

    public getClusterContextComboOptions = (): any => {
        return {
            id: "cluster",
            allowEdit: true,
            mode: "drop",
            value: this.clusterContextAndUrl(),
            source: this.clusterContextNameList(),
            enabled: this.enableClusterDropdown(),
            label: "Cluster",
            change: (combo: Controls_Combos.Combo) => {
                this.clusterContextAndUrl(combo.getInputText());
            },
            placeholderText: Resources.KubernetesClusterContextListPlaceholderText,
            refreshData: this.getClusterContexts
        }
    }

    public parseSaSecretYamlAndPopulateSaTokenAndSaCertfield = (): IPromise<boolean> => {
        let deferred: Q.Deferred<boolean> = Q.defer<boolean>();
        this.errors([]);
        let serviceAccountSecretYaml = this.serviceAccountSecretYaml();

        VSS.using(["3rdParty/js-yaml"], (jsyaml) => {
            try {
                var parsedServiceAccountSecret = jsyaml.safeLoad(serviceAccountSecretYaml);
                if (!parsedServiceAccountSecret) {
                    throw Resources.KuberntesInvalidServiceAccountSecretYaml;
                }

                if (!parsedServiceAccountSecret.data) {
                    throw Utils_String.localeFormat(Resources.KubernetesServiceAccountSecretFieldNotPresent, "data");
                }

                if (!parsedServiceAccountSecret.data.token) {
                    throw Utils_String.localeFormat(Resources.KubernetesServiceAccountSecretFieldNotPresent, "data.token");
                }

                if (!parsedServiceAccountSecret.data["ca.crt"]) {
                    throw Utils_String.localeFormat(Resources.KubernetesServiceAccountSecretFieldNotPresent, "data[ca.crt]");
                }

                this.serviceAccountToken(parsedServiceAccountSecret.data.token);
                this.serviceAccountCertificate(parsedServiceAccountSecret.data["ca.crt"]);
            }
            catch (error) {
                this.errors.push(error);
                deferred.reject(error);
            }
        });

        return deferred.promise;
    }

    private getKubeConfigFieldValue(inputs: any, keyField: string): any {
        var keys = Object.keys(inputs);
        if (keys.length > 0) {
            var keyFound = keys.find(function (key) {
                return Utils_String.equals(key, keyField, true);
            });

            return inputs[keyFound];
        }

        return null;
    }

    public getAzureSubscriptions(): IPromise<boolean> {
        var defer = Q.defer<boolean>();
        this.errors([]);
        this._distributedTaskClient.beginGetAzureSubscriptions().then((response: DistributedTask_Contracts.AzureSubscriptionQueryResult) => {
            if (!response.errorMessage) {
                let subscriptions: DistributedTask_Contracts.AzureSubscription[] = response.value;
                subscriptions.sort((a, b) => Utils_String.ignoreCaseComparer(this.getSubscriptionDisplayValue(a.subscriptionId, a.displayName), this.getSubscriptionDisplayValue(b.subscriptionId, b.displayName)));
                this.subscriptionList(subscriptions);
                defer.resolve(false);
            } else {
                this.errors.push(response.errorMessage);
                defer.resolve(true);
            }
        }, (error) => {
            this.errors.push(error.message);
            defer.resolve(true);
        });
        return defer.promise;
    }
    
    public getAzureSubscriptionsComboOptions = (): any => {
        const subscriptionAndIdList = this.subscriptionAndIdList.peek();
        if (this.subscriptionAndId.peek() === " (  )" && subscriptionAndIdList.length > 0) {
            this.subscriptionAndId(subscriptionAndIdList[0]);
        }

        var options = {
            allowEdit: false,
            mode: "drop",
            value: this.subscriptionAndId(),
            source: this.subscriptionAndIdList(),
            enabled: this.isAzureSubscriptionBasedInputsEnabled(),
            label: Resources.Subscription,
            change: (combo: Controls_Combos.Combo) => {
                this.subscriptionAndId(combo.getInputText());
            }
        };
        return options;
    }

    public getAksClusters = (): IPromise<boolean> => {
        if (!this.refreshClustersList()) {
            return Q.resolve(true);
        }

        let deferred = Q.defer<boolean>();
        this.errors([]);
        this.aksClustersList([]);
        
        VSS.using(["DistributedTasksCommon/ServiceEndpoints/AzureRMEndpointsManageDialog"], (AzureRMEndpointsManageDialog: typeof AzureRMEndpointsManageDialog_NO_REQUIRE) => {
            let azureEndpointDialogModel = new AzureRMEndpointsManageDialog.AddAzureRmEndpointsModel(() => { return; });
            azureEndpointDialogModel.subscriptionId(this.subscriptionId());
            azureEndpointDialogModel.subscriptionName(this.subscriptionName());
            azureEndpointDialogModel.tenantId(this.subscriptionTenantId());
            azureEndpointDialogModel.serverUrl(this.cloudUrl()); // we can get azureRm artifact type and get this url from it.
            
            if(this.spnCreationMode() == SpnCreateMethod.Manual)
            {
                azureEndpointDialogModel.spnKey(this.spnKey());
                azureEndpointDialogModel.spnClientId(this.spnClientId());
            }
            const authInProgress = (authInProgress: boolean) => {
                this.isOAuthFlowInProgress(authInProgress);
            };            
    
            let serviceEndpointAksClustersRequest: ServiceEndpoint_Contracts.ServiceEndpointRequest = {
                serviceEndpointDetails: azureEndpointDialogModel.getServiceEndpointDetails(),
                dataSourceDetails: {
                    dataSourceName: "AzureKubernetesClusters",
                    dataSourceUrl: "",
                    headers: null,
                    requestContent: null,
                    requestVerb: null,
                    resourceUrl: "",
                    parameters: {},
                    resultSelector: "",
                    initialContextTemplate: ""
                },
                resultTransformationDetails: {
                    "resultTemplate": null,
                    "callbackContextTemplate": null,
                    "callbackRequiredTemplate": null
                }
            };
        
            AzureRMEndpointsManageDialog.AzureRmEndpointUtils.getAccessTokenKey(this._distributedTaskClient, this.subscriptionTenantId(), authInProgress, this.oauthAccessTokenKey())
                .then((accessTokenKey: string) => {
                    serviceEndpointAksClustersRequest.serviceEndpointDetails.authorization.parameters["accessTokenType"] = "AppToken";
                    if (!!accessTokenKey) {
                        this.isOAuthFlowInProgress(false);
                        this.oauthAccessTokenKey(accessTokenKey);
                        serviceEndpointAksClustersRequest.serviceEndpointDetails.authorization.parameters["accesstoken"] = accessTokenKey;
                        serviceEndpointAksClustersRequest.serviceEndpointDetails.authorization.parameters["accessTokenFetchingMethod"] = ServiceEndpoint_Contracts.AccessTokenRequestType.Oauth.toString();
                    }
    
                    ServiceEndpoint_Common.recursivelyExecuteServiceEndpointRequest(this._distributedTaskClient, serviceEndpointAksClustersRequest, [])
                        .then((response: ServiceEndpoint_Contracts.ServiceEndpointRequestResult) => {
                            if (!!response.errorMessage) {
                                this.errors.push(response.errorMessage);
                                deferred.reject(false);
                            }
                            else {
                                try {
                                    let clusters: any[] = [];
                                    if (response.result) {
                                        response.result.forEach((cluster) => {
                                            clusters.push(JSON.parse(cluster));
                                        });
                                    }
        
                                    clusters.sort((a, b) => Utils_String.ignoreCaseComparer(this.getClusterDisplayName(a), this.getClusterDisplayName(b)));
                                    this.aksClustersList(clusters);
                                    this.refreshClustersList(false);
                                    deferred.resolve(true);
                                }
                                catch (e) {
                                    const errorMessage = Resources.ErrorWhileParsingKubernetesClustersResponse + e.message;
                                    this.errors.push(errorMessage);
                                    deferred.resolve(false);
                                }
                            }
                        }, (error) => {
                            
                            let errorMsg = error;
                            if (!!error && !!error.serverError && !!error.serverError.innerException) {
                                errorMsg = errorMsg + Utils_String.newLine + error.serverError.innerException.message;
                            }
    
                            this.errors.push(errorMsg);
                            deferred.reject(false);
                        }
                    );
    
                }, (error) => {
                    // invalidate the access token key
                    this.oauthAccessTokenKey(Utils_String.empty);
                    let errorMessage = Resources.ErrorWhileAuthorizingOnSubscription;
                    if (!!error) {
                        errorMessage = errorMessage + " " + Resources.ErrorPrefix + error;
                    }

                    this.errors.push(errorMessage);   
                    deferred.reject(false);
                }
            );    
        });
        
        return deferred.promise;
    }

    public getEnvironmentsComboOptions = (): any => {
        var options = {
            allowEdit: false,
            mode: "drop",
            value: this.selectedEnvironment() !== Utils_String.empty ? this.selectedEnvironment() : this.environmentsList()[0],
            source: this.environmentsList(),
            enabled: !this.isUpdate(),
            label: Resources.Environment,
            change: (combo: Controls_Combos.Combo) => {
                this.selectedEnvironment(combo.getInputText());
            }
        };
        return options;
    }

    public getAksClustersComboOptions = (): any => {
        var options = {
            allowEdit: false,
            mode: "drop",
            value: this.selectedClusterDisplayName(),
            source: this.aksClusterNamesList(),
            enabled: this.isAzureSubscriptionBasedInputsEnabled(),
            label: Resources.KubernetesCluster,
            change: (combo: Controls_Combos.Combo) => {
                const selectedValue = combo.getInputText();
                if (selectedValue) {
                    const indexOfSelectedEntry = this.aksClusterNamesList.peek().indexOf(selectedValue);
                    const selectedCluster = this.aksClustersList.peek()[indexOfSelectedEntry];
                    this.serverUrl(this.getServerUrlFromCluster(selectedCluster));
                    this.selectedClusterUrl(this.getServerUrlFromCluster(selectedCluster));
                    this.selectedClusterId(selectedCluster.id);
                }
            },
            refreshData: this.getAksClusters
        };

        return options;
    }

    public getKubernetesClusterNamespaces = (): IPromise<boolean> => {
        if (!this.refreshNamespacesList()) {
            return Q.resolve(true);
        }

        this.namespacesList([]);
        this.errors([]);
        let deferred = Q.defer<boolean>();

        VSS.using(["DistributedTasksCommon/ServiceEndpoints/AzureRMEndpointsManageDialog"], (AzureRMEndpointsManageDialog: typeof AzureRMEndpointsManageDialog_NO_REQUIRE) => {
            
            const authInProgress = (authInProgress: boolean) => {
                this.isOAuthFlowInProgress(authInProgress);
            };            
    
            this.authenticationScheme(ServiceEndpoint_Common.EndpointAuthorizationSchemes.Kubernetes)
            let endPoint = this.getServiceEndpoint().endPoint;
            let serviceEndpointKubernetesNamespacesRequest: ServiceEndpoint_Contracts.ServiceEndpointRequest = {
                serviceEndpointDetails: {
                    type: endPoint.type,
                    authorization: endPoint.authorization,
                    data: endPoint.data,
                    url: endPoint.url
                },
                dataSourceDetails: {
                    dataSourceName: "KubernetesNamespaces",
                    dataSourceUrl: "",
                    headers: null,
                    requestContent: null,
                    requestVerb: null,
                    resourceUrl: "",
                    parameters: null,
                    resultSelector: "",
                    initialContextTemplate: ""
                },
                resultTransformationDetails: null
            };
        
            AzureRMEndpointsManageDialog.AzureRmEndpointUtils.getAccessTokenKey(this._distributedTaskClient, this.subscriptionTenantId(), authInProgress, this.oauthAccessTokenKey())
                .then((accessTokenKey: string) => {
                    if (!!accessTokenKey) {
                        this.isOAuthFlowInProgress(false);
                        this.oauthAccessTokenKey(accessTokenKey); 
                        serviceEndpointKubernetesNamespacesRequest.serviceEndpointDetails.authorization.parameters["azureAccessToken"] = accessTokenKey;
                    }
    
                    this._distributedTaskClient.beginExecuteServiceEndpointRequest(serviceEndpointKubernetesNamespacesRequest, Utils_String.EmptyGuidString)
                        .then((response: ServiceEndpoint_Contracts.ServiceEndpointRequestResult) => {
                            if (!!response.errorMessage) {
                                this.errors.push(response.errorMessage);
                                deferred.reject(false);
                            }
                            else {
                                try {
                                    if (response.result) {
                                        response.result.forEach((namespace) => {
                                            let parsedNamespace = JSON.parse(namespace);
                                            if (parsedNamespace && parsedNamespace.metadata && parsedNamespace.metadata.name) {
                                                this.namespacesList.push(parsedNamespace.metadata.name);
                                            }                            
                                        });
                                    }
                
                                    this.refreshNamespacesList(false);
                                    deferred.resolve(true);
                                }
                                catch (e) {
                                    const errorMessage = Resources.ErrorWhileParsingKubernetesNamespacesResponse + e.message;
                                    this.errors.push(errorMessage);
                                    deferred.resolve(false);
                                }
                            }
                        }, (error) => {
                            
                            let errorMsg = error;
                            if (!!error && !!error.serverError && !!error.serverError.innerException) {
                                errorMsg = errorMsg + Utils_String.newLine + error.serverError.innerException.message;
                            }
            
                            this.errors.push(errorMsg);
                            deferred.reject(false);
                        }
                    );
    
                }, (error) => {
                    // invalidate the access token key
                    this.oauthAccessTokenKey(Utils_String.empty);
                    let errorMessage = Resources.ErrorWhileAuthorizingOnSubscription;
                    if (!!error) {
                        errorMessage = errorMessage + " Error: " + error;
                    }

                    this.errors.push(errorMessage);    
                    deferred.reject(false);
                }
            );
        });

        return deferred.promise;
    }   
    
    public getKubernetesClusterNamespacesComboOptions = (): any => {
        var options = {
            id: "namespace",
            allowEdit: false,
            mode: "drop",
            value: this.selectedNamespace(),
            source: this.namespacesList(),
            enabled: this.isAzureSubscriptionBasedInputsEnabled(),
            label: Resources.KubernetesNamespace,
            change: (combo: Controls_Combos.Combo) => {
                let selectedValue = combo.getInputText();
                if (selectedValue !== undefined && selectedValue !== null) {
                    this.selectedNamespace(selectedValue);
                }
            },
            refreshData: this.getKubernetesClusterNamespaces
        };

        return options;
    }

    private getSubscriptionDisplayValue(id: string, name: string): string {
        return name + " ( " + id + " )";
    }

    private getclusterNameFromClusterId(clusterId: string): string {
        let clusterName = Utils_String.empty;
        if (clusterId) {
            let parts = clusterId.split('/');
            let clusterNameIndex = parts.findIndex(part => Utils_String.equals(part, "managedClusters", true)) + 1;
            if (clusterNameIndex > 0) {
                clusterName = parts[clusterNameIndex];
            }
        }

        return clusterName;
    }   

    private getResourceGroupFromClusterId(clusterId: string): string {
        let resourceGroup = Utils_String.empty;
        if (clusterId) {
            let parts = clusterId.split('/');
            let resourceGroupIndex = parts.findIndex(part => Utils_String.equals(part, "resourcegroups", true)) + 1;
            if (resourceGroupIndex > 0) {
                resourceGroup = parts[resourceGroupIndex];
            }
        }

        return resourceGroup;
    }

    private getClusterDisplayName(cluster: any): string {
        if (!cluster) {
            return Utils_String.empty;
        }

        const resourceGroup = this.getResourceGroupFromClusterId(cluster.id);
        const clusterDisplayName = resourceGroup ? (cluster.name + " (" + resourceGroup + ")") : cluster.name;
        return clusterDisplayName || Utils_String.empty;
    }
    
    private getClusterDisplayNameFromClusterId(clusterId: string): string {
        const clusterName = this.getclusterNameFromClusterId(clusterId);
        const resourceGroup = this.getResourceGroupFromClusterId(clusterId);
        const clusterDisplayName = resourceGroup ? (clusterName + " (" + resourceGroup + ")") : clusterName;
        return clusterDisplayName;
    }

    private getServerUrlFromCluster(cluster: any): string {
        if (!cluster || !cluster.properties || !cluster.properties.fqdn) {
            this.errors.push(Resources.KubernetesCouldNotObtainClusterUrl);
            return Utils_String.empty;
        }

        return "https://" + cluster.properties.fqdn;
    }

    public isAzureSubscriptionBasedInputsEnabled() : boolean {
        return this.allowUpdatingAzureSubscriptionBasedInputs() && !this.serviceAccountSetupInProgress() && !this.isOAuthFlowInProgress();
    }

    public allowUpdatingAzureSubscriptionBasedInputs(): boolean {
        return !(this.isUpdate() && this.isExistingAuthorizationTypeAzureSubscription());
    }
}

export class AddKubernetesEndpointsDialog extends ServiceEndpoint_Controls.AddServiceEndpointDialog {
    protected _model: AddKubernetesEndpointModel;

    constructor(model: AddKubernetesEndpointModel) {
        super(model);
    }

    public initialize(): void {
        super.initialize();

        this.fetchAzureSubscriptionsIfRequired();

        this._model.authorizationType.subscribe(() => {
            this.fetchAzureSubscriptionsIfRequired();
        });

        this._model.subscriptionId.subscribe(() => {
            this._model.refreshClustersList(true);
            this._model.selectedClusterId(Utils_String.empty);
        });

        this._model.selectedClusterId.subscribe((selectedClusterId) => {
            this._model.selectedNamespace(Utils_String.empty);
            this._model.refreshNamespacesList(true);
        }); 
    }

    public getTitle(): string {
        var title = Resources.KubernetesTitle;
        if (this._model.title != "") {
            title = this._model.title;
        }

        this._model.dialogTitle(title);
        return title;
    }

    protected preCheck(): boolean {
        var checkFailed = false;

        //Input fields check
        this._element.find('input:visible').each((index: number, element: Element) => {
            //skipping check for cluster
            if ($(element).attr('id') !== "cluster_txt" && $(element).attr('id') !== "namespace_txt") {
                checkFailed = this._checkEmpty($(element));
            }

            return !checkFailed;
        });

        return checkFailed;
    }

    protected createServiceEndpoint(): IPromise<ServiceEndpoint_Contracts.ServiceEndpoint> {
        var defer = Q.defer<ServiceEndpoint_Contracts.ServiceEndpoint>();

        this._model.createServiceEndpoint().then((provisionEndpointResponse) => {
            defer.resolve(provisionEndpointResponse);
        }, (error) => {
            defer.reject(error);
        });

        return defer.promise;
    }

    protected updateServiceEndpoint(): IPromise<ServiceEndpoint_Contracts.ServiceEndpoint> {
        var defer = Q.defer<ServiceEndpoint_Contracts.ServiceEndpoint>();

        this._model.updateServiceEndpoint().then((provisionEndpointResponse) => {
            defer.resolve(provisionEndpointResponse);
        }, (error) => {
            defer.reject(error);
        });

        return defer.promise;
    }

    protected getServiceEndpointDetails(): ServiceEndpoint_Common.ServiceEndpointDetails {
        return this._model.getServiceEndpoint();
    }

    protected createView(): JQuery {
        return $(AddKubernetesEndpointsDialog._add_kubernetes_connection);
    }

    private fetchAzureSubscriptionsIfRequired(): void {
        if (this._model.allowUpdatingAzureSubscriptionBasedInputs() && this._model.isAzureSubscriptionAuthorization()) {
            this._model.getAzureSubscriptions().then((isFetchFailed) => {
                if (isFetchFailed) {
                    this._element.find(".error-messages-div").show();
                }
            });
        }
    }

    private static _add_kubernetes_connection = `
    <div class="add_kubernetes_connections_dialog services_dialog">
        <div id="connectionId" class="connectionId" data-bind="value: id, disable: isUpdate()"></div>
        <div data-bind="visible: serviceAccountSetupInProgress()">
            <span class="icon status-progress" data-bind="visible: pollingInProgress()"></span>
            <span><strong>${Resources.ServiceAccountSetupInProgress}</strong></span>
        </div>
        <table>
            <tr>
                <td>
                    <label id="authorizationRadioGroupLabel" class="required-input">${Resources.KubernetesChooseAuthTypeText}</label>
                </td>
                <td>
                    <div id="authorizationType" role="radiogroup" data-bind="attr: {'aria-label': authSchemeSelectorText}">
                        <span>
                            <input role="radio" name="kubernetesAuthorizationType" class="auth-kind" required type="radio" id="KubeconfigType" value="Kubeconfig" data-bind="checked: authorizationType, disable: serviceAccountSetupInProgress(), attr: { 'aria-checked': (authorizationType() === 'Kubeconfig') ? 'true' : 'false' }" />
                            <label for="KubeconfigType">${Resources.KubernetesKubeconfigAuthText}</label>
                        </span>
                        <span>
                            <input role="radio" name="kubernetesAuthorizationType" class="auth-kind" required type="radio" id="ServiceAccountType" value="ServiceAccount" data-bind="checked: authorizationType, disable: serviceAccountSetupInProgress(), attr: { 'aria-checked': (authorizationType() === 'ServiceAccount') ? 'true' : 'false' }" />
                            <label for="ServiceAccountType">${Resources.KubernetesServiceAccountAuthText}</label>
                        </span>
                        <span data-bind="visible: showAzureSubscriptionBasedOption()">
                            <input role="radio" name="kubernetesAuthorizationType" class="auth-kind" required type="radio" id="AzureSubscriptionType" value="AzureSubscription" data-bind="checked: authorizationType, disable: serviceAccountSetupInProgress(), attr: { 'aria-checked': (authorizationType() === 'AzureSubscription') ? 'true' : 'false' }" />
                            <label for="AzureSubscriptionType">${Resources.AzureSubscriptionText}</label>
                        </span>
                    </div>
                </td>
            </tr>
            <tr>
                <td>
                    <label for="connectionName" class="required-input">${Resources.ConnectionName}</label>
                </td>
                <td>
                    <input class="textbox" data-bind="value: name, css: { 'invalid': !name() }, valueUpdate: ['blur', 'afterkeydown'], disable: serviceAccountSetupInProgress()" required id="connectionName" type="text" />
                </td>
            </tr>

            <tr data-bind="visible: isAzureSubscriptionAuthorization() & isSpnCreationModeManual()">
                <td>
                    <label class="grid-row-element-col1" for="azureEnvironment">${Resources.Environment}</label>
                </td>
                <td>
                    <div class="pick-list  grid-row-element-col2" data-bind="dtcCombo: getEnvironmentsComboOptions(), attr: { id: id }"></div>
                </td>
                <td class="helpMarkDown padded" data-bind="showTooltip: { text: '${Resources.MSIEnvironmentTooltip}', minWidth: 200, pivotSiblingCssClass: 'value-field' }">
                </td>
            </tr>

            <tr data-bind="visible: showServerUrl()">
                <td>
                    <label for="serverUrl" class="required-input">${Resources.ServerUrl}</label>
                </td>
                <td>
                    <input class="textbox" required id="serverUrl" type="text" data-bind="value: serverUrl, css: { 'invalid': isServerUrlInvalid() }, valueUpdate: ['blur', 'afterkeydown']" />
                </td>
                <td class="helpMarkDown padded" data-bind="showTooltip: { text: kubernetesServerUrlHelpText, minWidth: 200, pivotSiblingCssClass: 'value-field' }">
                </td>
            </tr>

             <tr data-bind="visible: isKubeconfigAuthorization()">
                <td>
                    <label for="kubeConfig" class="required-input">${Resources.KubernetesKubeConfigText}</label>
                </td>
                <td>
                    <textarea class="textbox" required id="kubeConfig" data-bind="attr: { placeholder: (isUpdate()) ?  updateKubeconfigPlaceholderText : '' }, value: kubeConfig, css: { 'invalid': !isUpdate() && !kubeConfig() }, valueUpdate: ['blur', 'afterkeydown']"></textarea>
                </td>
                <td class="helpMarkDown padded" data-bind="showTooltip: { text: kubernetesHelpMarkdown, minWidth: 200, pivotSiblingCssClass: 'value-field' }">
                </td>
            </tr>

           <tr data-bind="visible: isKubeconfigAuthorization()">
                <td>
                    <label for="clusterContext">${Resources.KubernetesClusterContextText}</label>
                </td>
                <td>
                    <div class="pick-list" data-bind="dtcFetchingCombo: getClusterContextComboOptions()"></div>
                </td>
                <td class="helpMarkDown padded" data-bind="showTooltip: { text: kubernetesClusterHelpText, minWidth: 200, pivotSiblingCssClass: 'value-field' }">
                </td>
            </tr>

             <tr data-bind="visible: isServiceAccountAuthorization() & isNewServiceAccountUI() ">
                <td>
                    <label for="serviceAccountSecretYaml" class="required-input">${Resources.KubernetesServiceAccountSecretYaml}</label>
                </td>
                <td>
                    <textarea class="textbox" required id="serviceAccountSecretYaml" data-bind="attr: { placeholder: (isUpdate()) ? updateKubeconfigPlaceholderText : '' }, value: serviceAccountSecretYaml, css: { 'invalid': !isUpdate() && !serviceAccountSecretYaml() }, valueUpdate: ['blur', 'afterkeydown']"></textarea>
                </td>
                <td class="helpMarkDown padded" data-bind="showTooltip: { text: kubernetesServiceAccountSecretYamlHelpText, minWidth: 200, pivotSiblingCssClass: 'value-field' }">
                </td>
            </tr>

            <tr data-bind="visible: isServiceAccountAuthorization() & !isNewServiceAccountUI() ">
                <td>
                    <label for="serviceAccountToken" class="required-input">${Resources.KubernetesServiceAccountToken}</label>
                </td>
                <td>
                    <textarea class="textbox" required id="serviceAccountToken" data-bind="attr: { placeholder: (isUpdate()) ? updateKubeconfigPlaceholderText : '' }, value: serviceAccountToken, css: { 'invalid': !isUpdate() && !serviceAccountToken() }, valueUpdate: ['blur', 'afterkeydown']"></textarea>
                </td>
                <td class="helpMarkDown padded" data-bind="showTooltip: { text: kubernetesServiceAccountTokenHelpText, minWidth: 200, pivotSiblingCssClass: 'value-field' }">
                </td>
            </tr>

            <tr data-bind="visible: isAzureSubscriptionAuthorization() & isSpnCreationModeAutomatic()">
                <td>
                    <label class="required-input">${Resources.AzureSubscriptionText}</label>
                </td>
                <td>
                    <div class="pick-list grid-row-element-col2" data-bind="dtcCombo: getAzureSubscriptionsComboOptions()"></div>
                </td>
                <td class="helpMarkDown padded" data-bind="showTooltip: { text: kubernetesAzureSubscriptionHelpText, minWidth: 200, pivotSiblingCssClass: 'value-field' }">
                </td>
            </tr>

            <tr data-bind="visible: isAzureSubscriptionAuthorization() & isSpnCreationModeManual()">
                <td>
                    <label class="required-input">${Resources.AzureSubscriptionText}</label>
                </td>
                <td>
                    <input class="textbox" data-bind="value: subscriptionId, css: { 'invalid': !subscriptionId() }, valueUpdate: ['blur', 'afterkeydown'], disable: serviceAccountSetupInProgress()" required id="subscriptionId" type="text" />
                </td>
                <td class="helpMarkDown padded" data-bind="showTooltip: { text: kubernetesAzureSubscriptionHelpText, pivotSiblingCssClass: 'value-field' }">
                </td>
            </tr>

            <tr data-bind="visible: isAzureSubscriptionAuthorization() & isSpnCreationModeManual()">
                <td>
                    <label class="required-input">${Resources.AzureSubscriptionNameText}</label>
                </td>
                <td>
                    <input class="textbox" data-bind="value: subscriptionName, css: { 'invalid': !subscriptionName() }, valueUpdate: ['blur', 'afterkeydown'], disable: serviceAccountSetupInProgress()" required id="subscriptionName" type="text" />
                </td>
                <td class="helpMarkDown padded" data-bind="showTooltip: { text: kubernetesAzureSubscriptionHelpText, pivotSiblingCssClass: 'value-field' }">
                </td>
            </tr>

            <tr data-bind="visible: isAzureSubscriptionAuthorization() & isSpnCreationModeManual()">
                <td>
                    <label class="required-input">${Resources.AzureServicePrincipalIdText}</label>
                </td>
                <td>
                    <input class="textbox" data-bind="value: spnClientId, css: { 'invalid': !spnClientId() }, valueUpdate: ['blur', 'afterkeydown'], disable: serviceAccountSetupInProgress()" required id="spnClientId" type="text" />
                </td>
                <td class="helpMarkDown padded" data-bind="showTooltip: { text: kubernetesAzureSubscriptionHelpText, pivotSiblingCssClass: 'value-field' }">
                </td>
            </tr>

            <tr data-bind="visible: isAzureSubscriptionAuthorization() & isSpnCreationModeManual()">
                <td>
                    <label class="required-input">${Resources.AzureServicePrincipalKeyText}</label>
                </td>
                <td>
                    <input class="textbox" type="password" data-bind="attr: { placeholder: isUpdate() ? '********' : '' }, value: spnKey, css: { 'invalid': !spnKey() }, valueUpdate: ['blur', 'afterkeydown']" required id="spnKey" type="text" />
                </td>
                <td class="helpMarkDown padded" data-bind="showTooltip: { text: kubernetesAzureSubscriptionHelpText, pivotSiblingCssClass: 'value-field' }">
                </td>
            </tr>

            <tr data-bind="visible: isAzureSubscriptionAuthorization() & isSpnCreationModeManual()">
                <td>
                    <label class="required-input">${Resources.AzureTenantId}</label>
                </td>
                <td>
                    <input class="textbox" data-bind="value: subscriptionTenantId, css: { 'invalid': !subscriptionTenantId() }, valueUpdate: ['blur', 'afterkeydown'], disable: serviceAccountSetupInProgress()" required id="subscriptionTenantId" type="text" />
                </td>
                <td class="helpMarkDown padded" data-bind="showTooltip: { text: kubernetesAzureSubscriptionHelpText, pivotSiblingCssClass: 'value-field' }">
                </td>
            </tr>

            <tr data-bind="visible: isAzureSubscriptionAuthorization() & isSpnCreationModeManual()" class="input-required">
                <td>
                    <label class="required-input">${Resources.KubernetesAksClusterId}</label>
                </td>
                <td>
                    <input class="textbox" data-bind="value: selectedClusterId, css: { 'invalid': !selectedClusterId() }, valueUpdate: ['blur', 'afterkeydown'], disable: serviceAccountSetupInProgress()" required id="selectedClusterId" type="text" />
                </td>
                <td class="helpMarkDown padded" data-bind="showTooltip: { text: kubernetesAksClusterHelpText, minWidth: 200, pivotSiblingCssClass: 'value-field' }">
                </td>
            </tr>

            <tr data-bind="visible: isAzureSubscriptionAuthorization() & isSpnCreationModeAutomatic()" class="input-required">
                <td>
                    <label class="required-input">${Resources.KubernetesAksCluster}</label>
                </td>
                <td>
                    <div class="pick-list grid-row-element-col2" data-bind="dtcFetchingCombo: getAksClustersComboOptions()"></div>
                </td>
                <td class="helpMarkDown padded" data-bind="showTooltip: { text: kubernetesAksClusterHelpText, minWidth: 200, pivotSiblingCssClass: 'value-field' }">
                </td>
            </tr>

            <tr data-bind="visible: isAzureSubscriptionAuthorization() & isSpnCreationModeAutomatic()">
                <td>
                    <label for="clusterNamespace">${Resources.KubernetesNamespace}</label>
                </td>
                <td>
                    <div class="pick-list grid-row-element-col2" data-bind="dtcFetchingCombo: getKubernetesClusterNamespacesComboOptions()"></div>
                </td>
                <td class="helpMarkDown padded" data-bind="showTooltip: { text: kubernetesNamespaceHelpText, minWidth: 200, pivotSiblingCssClass: 'value-field' }">
                </td>
            </tr>

            <tr data-bind="visible: isAzureSubscriptionAuthorization() & isSpnCreationModeManual()" class="input-required">
                <td>
                    <label for="required-input">${Resources.KubernetesNamespace}</label>
                </td>
                <td>
                    <input class="textbox" data-bind="value: selectedNamespace, css: { 'invalid': !selectedNamespace() }, valueUpdate: ['blur', 'afterkeydown'], disable: serviceAccountSetupInProgress()" required id="selectedNamespace" type="text" />
                </td>
                <td class="helpMarkDown padded" data-bind="showTooltip: { text: kubernetesNamespaceHelpText, minWidth: 200, pivotSiblingCssClass: 'value-field' }">
                </td>
            </tr>
			
			<tr data-bind="visible: isAzureSubscriptionAuthorization() & isSpnCreationModeManual()" class="input-required">
                <td>
                    <label for="required-input">${Resources.KubernetesClusterUrl}</label>
                </td>
                <td>
                    <input class="textbox" data-bind="value: selectedClusterUrl, css: { 'invalid': !selectedClusterUrl() }, valueUpdate: ['blur', 'afterkeydown'], disable: serviceAccountSetupInProgress()" required id="selectedClusterUrl" type="text" />
                </td>
                <td class="helpMarkDown padded" data-bind="showTooltip: { text: kubernetesAksClusterHelpText, minWidth: 200, pivotSiblingCssClass: 'value-field' }">
                </td>
            </tr>

            <tr data-bind="visible: isAzureSubscriptionAuthorization() & isExistingAuthorizationTypeAzureSubscription() & isSpnCreationModeAutomatic()">
                <td>
                    <label for="renewServiceAccount">${Resources.KubernetesRenewServiceAccount}</label>
                </td>
                <td>
                    <input id="renewServiceAccount" type="checkbox" data-bind="checked: renewServiceAccount, disable: serviceAccountSetupInProgress() || isOAuthFlowInProgress(), valueUpdate: ['blur', 'afterkeydown']"/>
                </td>
                <td class="helpMarkDown padded" data-bind="showTooltip: { text: kubernetesRenewServiceAccountHelpText, minWidth: 200, pivotSiblingCssClass: 'value-field' }">
                </td>
            </tr>
            
	    <tr data-bind="visible: isServiceAccountAuthorization() & !isNewServiceAccountUI()" class="input-required">
                <td>
                    <label for="serviceAccountCertificate" class="required-input">${Resources.KubernetesServiceAccountCertificate}</label>
                </td>
                <td>
                    <textarea class="textbox" required id="serviceAccountCertificate" data-bind="attr: { placeholder: (isUpdate()) ? updateKubeconfigPlaceholderText : '' }, value: serviceAccountCertificate, css: { 'invalid': !isUpdate() && !serviceAccountCertificate() }, valueUpdate: ['blur', 'afterkeydown']"></textarea>
                </td>
                <td class="helpMarkDown padded" data-bind="showTooltip: { text: kubernetesServiceAccountCertificateHelpText, minWidth: 200, pivotSiblingCssClass: 'value-field' }">
                </td>
            </tr>

            <tr data-bind="visible: isKubeconfigAuthorization()">
               <td>
                    <label for="acceptUntrustedCerts">${Resources.KubernetesAcceptUntrustedCerts}</label>
                </td>
                <td>
                    <input id="acceptUntrustedCerts" type="checkbox" data-bind="checked: acceptUntrustedCerts, css: { 'invalid': !acceptUntrustedCerts() }, valueUpdate: ['blur', 'afterkeydown']"/>
                </td>
                <td class="helpMarkDown padded" data-bind="showTooltip: { text: acceptUntrustedCertsHelpText, minWidth: 200, pivotSiblingCssClass: 'value-field' }">
                </td>
            </tr>
        </table>
        <table>
            <tbody>
                <tr data-bind="visible: isServiceAccountAuthorization()">
                    <td><label for="kubernetesServiceAccountDetails">${Resources.KubernetesServiceAccountDetailsHelpHeaderText}</label></td>
                </tr>

                <tr data-bind="visible: isServiceAccountAuthorization()">
                    <td colspan="4" data-bind="html: kubernetesServiceAccountDetailsText"></td>
                </tr>
            </tbody>
            <tbody class="verify-connection-container" data-bind="visible: showVerifyConnection()">
                <tr>
                    <td class="header-line td" colspan="3">
                        <div class="header"></div>
                    </td>
                </tr>
                <tr>
                    <td style="min-width:150px">
                        <div class="verify-connection-status">
                            <span>${Resources.ConnectionLabel}</span>
                            <span class="bowtie-icon dialog-field-tooltip" data-bind="css: verifyConnectionStatusCssIconClass"></span>
                            <span class="status-main" data-bind="text: verifyConnectionStatus, css: verifyConnectionStatusCssTextClass"></span>
                        </div>
                    </td>
                    <td>
                        <div class="verify-action">
                            <span data-bind="click: verifyConnection, event: { keydown: onKeyDown }"><a tabindex="0" role="button">${Resources.VerifyConnection}</a></span>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="footer-line td" colspan="3">
                        <div class="footer"></div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div tabindex="0" class="error-messages-div">
            <div data-bind="foreach: errors">
                <span role="alert" data-bind="text: $data"></span><br />
            </div>
        </div>
        <div tabindex="0" class="operation-status-message-div" data-bind="visible: isAzureSubscriptionAuthorization && operationStatusMessage">
            <span role="alert" data-bind="text: operationStatusMessageWithPrefix"></span><br />
        </div>
        <div data-bind="visible: isAzureSubscriptionAuthorization() & isSpnCreationModeAutomatic() & isSovereignFeatureEnabled()">
        <span class="getting-started-lighttext getting-started-vertical-small"><a role="button" tabindex="0" data-bind="click: switchSpnCreationMode, event: { keydown: onKeyDown }">${Resources.UseManualSpnWindowFooterLink}</a></span>
        </div>
        <div data-bind="visible: isAzureSubscriptionAuthorization() & isSpnCreationModeManual()">
        <span class="getting-started-lighttext getting-started-vertical-small"><a role="button" tabindex="0" data-bind="click: switchSpnCreationMode, event: { keydown: onKeyDown }">${Resources.UseAutoSpnCreateWindowFooterLink}</a></span>
        </div>
        <span data-bind="html: learnMoreAboutKubernetesLink()"></span>
    </div>`;
}

VSS.tfsModuleLoaded("KubernetesEndpointManageDialog", exports);

